var _circle, _path, _path2, _path3, _circle2, _circle3, _circle4, _circle5, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowerHead({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    stroke: "#5E6368",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "#FFF",
    r: 4.7,
    cy: 51,
    cx: 48.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5E6368",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "#FFF",
    d: "M48.1 53.1c-1.4 0-3.6.8-5.3 1.3-.3.1-.4-.2-.2-.4 4.3-3.9 4.3-4.3 5.3-9.1.1-.3.4-.3.5 0 1.1 4.8 1.1 5.3 5.3 9.1.2.2 0 .5-.2.4-1.8-.5-4-1.3-5.4-1.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5E6368",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M52.9 18.4c0-.5-.1-.5-.6-.7-2.8-1.1-2.6-3.6-4.3-3.6s-1.5 2.5-4.3 3.6c-.4.2-.6.2-.6.7h9.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#74AA4E",
    strokeDasharray: "1.1367,1.8944",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    fill: "none",
    d: "M44.5 21.5V36m4.7-14.5V38m-2.3-17.8v16.1m4.6-16.1v16.1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#5E6368",
    r: 0.6,
    cy: 18.7,
    cx: 46.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#5E6368",
    r: 0.6,
    cy: 18.7,
    cx: 49.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#5E6368",
    r: 0.6,
    cy: 18.7,
    cx: 51.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#5E6368",
    r: 0.6,
    cy: 18.7,
    cx: 44.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5E6368",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M41.6 76.1h-5.5c-3.8 0-8 1.7-11.4 4.7l-4.2 3.7m33.9-8.4h5.5c3.8 0 8 1.7 11.4 4.7l4.2 3.7m-53-75h51.1m-25.7 4.6v-2.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowerHead);
export default __webpack_public_path__ + "static/media/shower-head.35d94f7faf86f3d186a54ae6ee0e05f6.svg";
export { ForwardRef as ReactComponent };